import dayjs from 'dayjs';
import { fromPairs, isNil, map, pipe } from 'ramda';

import { PremiumPay, PremiumPayFlagsEnum } from '../../../types';
import { FlagField, PremiumPayFormValues, PremiumPayForSave } from '../types';
import { CLAOption } from 'types';

import { isSvcTypeBonus } from '../../../utils/utils';

const mapFormFlagsForApi = (formFlagsData: FlagField[]) => {
  const flagsArr: PremiumPayFlagsEnum[] = [];
  for (const flag in formFlagsData) {
    if (formFlagsData[flag]) {
      flagsArr.push(PremiumPayFlagsEnum[flag]);
    }
  }
  return flagsArr;
};

export const convertResponseToForm = (
  data: PremiumPay
): PremiumPayFormValues => {
  return {
    ...data,
    bonusTypeSvcName: data.bonusTypeSvc ?? '',
    bonusTypeSvc: {
      label: data.bonusTypeSvc,
      value: data.bonusTypeSvc
    },
    valid: {
      from: new Date(data.valid.from),
      to: new Date(data.valid.to)
    },
    timeFrom: dayjs(data.timeFrom),
    timeTo: dayjs(data.timeTo),
    timeFromThr: !isNil(data?.timeFromThr)
      ? dayjs(data.timeFromThr)
      : undefined,
    timeToThr: !isNil(data?.timeToThr) ? dayjs(data.timeToThr) : undefined,
    flags: pipe(
      map<string, [string, boolean]>((value) => [value, true]),
      fromPairs
    )(data.flags) as unknown as FlagField[],
    scPri: data.scPri ?? '',
    scSec: data.scSec ?? ''
  };
};

export const convertPayloadForSave = (
  data: PremiumPayFormValues,
  premiumPayTypes: CLAOption[] | undefined
): PremiumPayForSave => {
  return {
    percentage: data.percentage,
    columnNr: data.columnNr,
    bonusTypeSvc: data?.bonusTypeSvc?.value,
    valid: {
      from: data.valid.from?.toISOString(),
      to: data.valid.to?.toISOString()
    },
    flags: mapFormFlagsForApi(data.flags),
    timeFrom: data.timeFrom.toISOString(),
    timeTo: data.timeTo.toISOString(),
    claId:
      premiumPayTypes &&
      premiumPayTypes.filter((item) => item.code == data.claCode)[0].claId,
    ...(data?.claBonusId && {
      claBonusId: data.claBonusId
    }),
    ...(data?.timeFromThr && {
      timeFromThr: data.timeFromThr.toISOString()
    }),
    ...(data?.timeToThr && {
      timeToThr: data.timeToThr.toISOString()
    }),
    ...(data?.maxHoursPerDayrange && {
      maxHoursPerDayrange: data.maxHoursPerDayrange
    }),
    bonus25Method:
      isSvcTypeBonus(data.bonusTypeSvc?.label) && data?.bonus25Method
        ? data.bonus25Method
        : null,
    scPri: data.scPri,
    scSec: data.scSec,
    maxHoursPerDayrange:
      isSvcTypeBonus(data.bonusTypeSvc?.label) && data?.maxHoursPerDayrange
        ? data.maxHoursPerDayrange
        : 0,
    dayrange:
      isSvcTypeBonus(data.bonusTypeSvc?.label) && data?.dayrange
        ? data.dayrange
        : null
  };
};
